import React, { CSSProperties, useEffect, useRef } from "react";

import { styled, Typography } from '@material-ui/core';
import { formatNumber } from "../utils/formatNumber";
import { useState } from "react";


const NumContainer = styled(Typography)({})

interface Props {
  number?: number | null;
  prefix?: string;
}

type CompState = 'up' | 'down' | null;

function usePrevious(value: any) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}



const NumberValue: React.FC<Props> = ({ number, prefix }) => {
  const green = '#3caf18';
  const red = '#f44336';

  const [ state, setState ] = useState<CompState>(null);

  

  const prevNum = usePrevious(number) as any;

  useEffect(() => {
    let timer: any;
    if (typeof number === 'undefined' || number === null || typeof prevNum === 'undefined' || prevNum === null) {
      return;
  }

    if (number === prevNum) {
      return;
    }

    if (number > prevNum) {
      setState('up');
    }
    else if (number < prevNum) {
      setState('down');
    }

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      setState(null);
    }, 500);


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ number ]);

  const style: CSSProperties = {};
  if (state === 'up') {
    style.color = green;
    style.fontWeight = 500;
  }
  else if (state === 'down') {
    style.color = red;
    style.fontWeight = 500;
  }

  return (
    <NumContainer style={style}>
      {
        prefix ? `${prefix} ${formatNumber(number ?? 0)}` : formatNumber(number ?? 0)
      }
    </NumContainer>
  );
};

export default NumberValue;